import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";
import { socialLinks, brandEmail } from "@/data/brand";

const col1 = [
  { label: "All Products", to: "/shop" },
  { label: "Hoodies", to: "/shop?type=hoodies" },
  { label: "Tees", to: "/shop?type=tees" },
  { label: "Shorts", to: "/shop?type=shorts" },
  { label: "Bundles", to: "/shop?type=bundles" },
];

const col2 = [
  { label: "All Drops", to: "/drops" },
  { label: "International Drops", to: "/drops?tab=international" },
  { label: "Domestic Drops", to: "/drops?tab=domestic" },
  { label: "Archive", to: "/drops?tab=archive" },
];

const col3 = [
  { label: "Our Story", to: "/our-story" },
  { label: "The Wrong Conception", to: "/our-story" },
  { label: "Contact", to: "/contact" },
  { label: "Press", to: "/contact" },
];

export const Footer = () => {
  return (
    <footer
      className="bg-black text-white border-t border-white/20 pt-20 pb-10 px-6 md:px-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="wc-heading text-3xl md:text-5xl tracking-[0.2em]">WRONGCONCEPTION</div>
          <div className="wc-label text-xs text-white/60 mt-3">
            Everyone has the wrong conception.
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          <FooterCol heading="SHOP" items={col1} testidPrefix="footer-shop" />
          <FooterCol heading="DROPS" items={col2} testidPrefix="footer-drops" />
          <FooterCol heading="BRAND" items={col3} testidPrefix="footer-brand" />
          <div>
            <div className="wc-label text-xs text-white mb-5">CONNECT</div>
            {(socialLinks.instagram || socialLinks.tiktok || socialLinks.youtube) && (
              <div className="flex gap-5 mb-5">
                {socialLinks.instagram && (
                  <a
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Instagram"
                    className="text-white hover:opacity-60 transition-opacity"
                    data-testid="footer-instagram"
                  >
                    <Instagram size={20} />
                  </a>
                )}
                {socialLinks.tiktok && (
                  <a
                    href={socialLinks.tiktok}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="TikTok"
                    className="text-white hover:opacity-60 transition-opacity"
                    data-testid="footer-tiktok"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.1z" />
                    </svg>
                  </a>
                )}
                {socialLinks.youtube && (
                  <a
                    href={socialLinks.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="YouTube"
                    className="text-white hover:opacity-60 transition-opacity"
                    data-testid="footer-youtube"
                  >
                    <Youtube size={22} />
                  </a>
                )}
              </div>
            )}
            <a
              href={`mailto:${brandEmail}`}
              className="text-white/80 text-sm hover:text-white"
              data-testid="footer-email"
            >
              {brandEmail}
            </a>
          </div>
        </div>

        <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row justify-between gap-3 text-[11px] wc-label text-white/40">
          <div>WRONGCONCEPTION 2026. ALL RIGHTS RESERVED.</div>
          <div>STREETWEAR. REAL STORIES. NO PROMISE IT RETURNS.</div>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ heading, items, testidPrefix }) => (
  <div>
    <div className="wc-label text-xs text-white mb-5">{heading}</div>
    <ul className="space-y-3">
      {items.map((i) => (
        <li key={i.label}>
          <Link
            to={i.to}
            className="text-sm text-white/70 hover:text-white transition-colors"
            data-testid={`${testidPrefix}-${i.label.toLowerCase().replace(/\s+/g, "-")}`}
          >
            {i.label}
          </Link>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
